import { useEffect, useRef } from "react";
export default function useOnEscPress(cb) {
    const cbRef = useRef(cb);
    cbRef.current = cb;
    useEffect(() => {
        const handler = (ev) => {
            if (ev.key === 'Escape') {
                cbRef.current();
            }
        };
        document.addEventListener('keydown', handler);
        document.addEventListener('keypress', handler);
        return () => {
            document.removeEventListener('keypress', handler);
            document.removeEventListener('keydown', handler);
        };
    }, []);
}
